import { useState } from "react";
import { useTranslation } from "react-i18next";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { SectionLayout } from "@/layouts";
import * as Styled from "./steps.styles";

export const Steps = () => {
  const { t } = useTranslation("global");
  const [activeStep, setActiveStep] = useState(1);
  const [active, setActive] = useState(false);

  const handleStepBottom = () => {
    if (activeStep === 4) {
      setActive(true);
      setActiveStep(1);
    } else {
      setActiveStep(activeStep + 1);
      setActive(true);
    }
    setTimeout(() => {
      setActive(false);
    }, 1000);
  };

  const handleStepTop = () => {
    if (activeStep === 1) {
      setActiveStep(4);
      setActive(true);
    } else {
      setActiveStep(activeStep - 1);
      setActive(true);
    }
    setTimeout(() => {
      setActive(false);
    }, 1000);
  };

  return (
    <SectionLayout id="steps" bgColor="var(--on-primary-dark)">
      <div style={{ width: "100%" }}>
        <Styled.SelectorBox onClick={handleStepTop}>
          <KeyboardArrowUpIcon />
        </Styled.SelectorBox>
        {/*body*/}
        <div>
          <Styled.ImgContainer>
            <Styled.ImgBoxSmall>
              <Styled.Img
                step={activeStep}
                src="/assets/freeTrial/stepsImg/steps.svg"
                alt="mockup-cellect"
              />
            </Styled.ImgBoxSmall>
          </Styled.ImgContainer>
          {/*content*/}
          <Styled.DescriptionContainer>
            <Styled.NumSelectorsBox className="section">
              <div>
                <Styled.NumSelectors className="display-large weight-medium">
                  01
                </Styled.NumSelectors>
                <Styled.NumSelectors className="display-large weight-medium">
                  02
                </Styled.NumSelectors>
                <Styled.NumSelectors className="display-large weight-medium">
                  03
                </Styled.NumSelectors>
                <Styled.NumSelectors className="display-large weight-medium">
                  04
                </Styled.NumSelectors>
              </div>
            </Styled.NumSelectorsBox>

            <Styled.TextContainer>
              <Styled.CardTitle
                className={`${
                  active
                    ? "display-medium weight-medium animate__animated animate__fadeIn animate_slower"
                    : "display-medium weight-medium"
                }`}
              >
                {t(`freeTrialSteps.step${activeStep}.title`)}
              </Styled.CardTitle>
              <Styled.CardDescription
                className={`${
                  active
                    ? "body-medium animate__animated animate__fadeIn animate_slower"
                    : "body-medium"
                }`}
              >
                {t(`freeTrialSteps.step${activeStep}.description`)}
              </Styled.CardDescription>
              <Styled.TextStartNow className="body-medium weight-medium">
                {t("freeTrialSteps.freeTrial")}
              </Styled.TextStartNow>
            </Styled.TextContainer>
          </Styled.DescriptionContainer>
        </div>
        <Styled.SelectorBox onClick={handleStepBottom}>
          <KeyboardArrowDownIcon />
        </Styled.SelectorBox>
        <div
          style={{
            backgroundColor: "var(--primary-light)",
            height: "5rem",
            display: "flex",
            justifyContent: "center",
          }}
        >
          here we will have the slider
        </div>
      </div>
    </SectionLayout>
  );
};
